import RCPagination from 'rc-pagination';
import styled, { css } from 'styled-components';

import { paginationConsts } from './Pagination.consts';
import { PaginationPosition, PaginationSize } from './Pagination.types';

interface PaginationProps {
  prefixCls: string;
  position: PaginationPosition;
  size: PaginationSize;
}

const Pagination = styled(RCPagination)<PaginationProps>`
  ${({ prefixCls, position, size, theme }) => css`
    display: flex;
    justify-content: ${position};
    align-items: center;
    ${size === 'small' && theme.label.small.normal};
    ${size === 'medium' && theme.label.medium.normal};
    ${size === 'large' && theme.label.large.normal};
    padding: 0;
    list-style-type: none;

    .${prefixCls} {
      &-item,
      &-prev,
      &-next,
      &-jump-prev,
      &-jump-next {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 40px;
        height: 40px;
        ${(size === 'medium' || size === 'small') && theme.label.medium.bold};
        ${size === 'large' && theme.label.large.bold};

        font-weight: bold;
        margin-right: ${paginationConsts.margin};
        border: 1px solid #adadad;
        border-radius: 2px;
        cursor: pointer;

        ${size === 'small' &&
        css`
          width: 32px;
          height: 32px;
        `}

        ${size === 'large' &&
        css`
          width: 48px;
          height: 48px;
        `}
      }

      &-prev,
      &-next,
      &-jump-prev,
      &-jump-next {
        > svg {
          width: 24px;
          height: 24px;

          ${size !== 'large' &&
          css`
            width: 20px;
            height: 20px;
          `}
        }

        &.${prefixCls}-disabled {
          border-color: ${theme.text.onSurface.inactive};
          cursor: not-allowed;

          > svg path {
            fill: ${theme.text.onSurface.inactive};
          }
        }
      }

      &-next {
        margin-right: 0;
      }

      &-jump-prev,
      &-jump-next {
        border: none;
        outline: none;
        display: flex;
      }

      &-item-active {
        border-color: ${theme.focus.strong};
        color: ${theme.focus.strong};
      }

      &-item-link {
        background: transparent;
        border: none;
        cursor: pointer;
        color: ${theme.text.onSurface.strong};

        &:after {
          display: block;
          content: '•••';
        }
      }

      input {
        height: 40px;
        padding: ${paginationConsts.inputPadding[size]};
        border: 1px solid ${theme.border.medium};
        border-radius: 2px;
        background: ${theme.background.surface};
        outline: none;
        opacity: 1;
      }

      &-simple-pager {
        margin-right: ${paginationConsts.margin};

        > * {
          margin-right: 4px;
        }
      }

      &-total-text {
        margin-right: ${paginationConsts.margin};
      }

      &-options {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-left: ${paginationConsts.margin};
        font-weight: normal;

        &-quick-jumper {
          display: flex;
          align-items: center;

          input {
            width: 150px;
            margin: 0 ${paginationConsts.margin};
          }
        }
      }
    }
  `}
`;

export { Pagination };
